<template>
  <component
    :is="tag"
    class="chip"
    :class="{ 'chip--selected': selected }"
    :href="href"
  >
    <slot />
  </component>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  href: {
    type: String,
    default: null
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const tag = computed(() => (props.href ? 'a' : 'span'))
</script>
<style lang="scss" scoped>
.chip {
  display: block;
  padding: 6px 12px;
  border-radius: 80px;
  background: $gray-3;
  font-size: 10px;
  line-height: 160%;
  color: #000;
  cursor: pointer;
  white-space: nowrap;

  &--selected {
    background: #232323;
    color: #fff;
    font-weight: bold;
  }
}
</style>
